import { getAllCategories, getAllPosts } from '@lib/sanity';
import Layout from '@molecules/Layout';
import type { LayoutProps } from '@molecules/Layout/Layout.types';
import { getClient } from '@sanity/lib/getClient';
import SitemapView from '@views/SitemapView';
import type { SitemapViewProps } from '@views/SitemapView/SitemapView.types';
import type { GetStaticProps } from 'next';
import type { ReactElement } from 'react';

import { mapLayout } from '@/mappers/layout';
import { mapSitemap } from '@/mappers/sitemap';

interface SitemapProps {
  layoutData: Omit<LayoutProps, 'children'>;
  sitemapData: SitemapViewProps;
}

const Sitemap = ({ sitemapData, layoutData }: SitemapProps): ReactElement => (
  <Layout {...layoutData}>
    <SitemapView {...sitemapData} />
  </Layout>
);

export const getStaticProps: GetStaticProps<SitemapProps> = async () => {
  const client = getClient();
  const categories = await getAllCategories(client);
  const layoutData = mapLayout(categories);
  const posts = await getAllPosts(client);
  const sitemapData = mapSitemap(categories, posts, posts);

  return {
    props: {
      layoutData,
      sitemapData,
    },
  };
};

export default Sitemap;
